import { observer } from 'mobx-react-lite';
import PageInnerContainer from 'pages/components/pageInnerContainer';
import { FolderModel } from 'entities/folder/model/folderModel';
import TrashPageHeader from 'pages/trash/trashPageHeader';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TrashContentGridController from 'widgets/grids/trashContentGridController';
import FinallyDeleteFolderModalController from 'widgets/folders/finallyDeleteFolderModalController';
import RestoreFolderModalController from 'widgets/folders/restoreFolderModalController';

export default observer(function TrashExplorerFolder({
  folderModel,
}: {
  folderModel: FolderModel;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isRestore, setIsRestore] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  return folderModel?.data ? (
    <PageInnerContainer>
      <TrashPageHeader
        text={folderModel.name || ''}
        clearText={t('common.delete')}
        restoreText={t('common.restore')}
        onRestore={() => setIsRestore(true)}
        onClear={() => setIsDelete(true)}
      ></TrashPageHeader>

      <TrashContentGridController
        items={folderModel.content}
        sort={{ key: folderModel.sortKey, order: folderModel.sortOrder }}
        onSortChange={(val) => {
          folderModel.sortKey = val.key;
          folderModel.sortOrder = val.order;
          folderModel.getContent({ in_trash: null });
        }}
        afterFileDelete={(id) => {
          folderModel.localDeleteFile(id);
        }}
        afterFileRestore={(item) => {
          folderModel.localDeleteFile(item.id);
        }}
        afterTableRestore={(item) => {
          folderModel.localDeleteTable(item.id);
        }}
        afterTableDelete={(id) => {
          folderModel.localDeleteTable(id);
        }}
        afterFolderRestore={(data) => {
          folderModel.localDeleteFolders([data.id]);
        }}
        afterFolderFinallyDelete={(id) => {
          folderModel.localDeleteFolders([id]);
        }}
      ></TrashContentGridController>

      {isRestore && (
        <RestoreFolderModalController
          folder={folderModel.data}
          handleClose={() => setIsRestore(false)}
          afterFolderRestore={() => navigate('/trash')}
        ></RestoreFolderModalController>
      )}

      {isDelete && (
        <FinallyDeleteFolderModalController
          id={folderModel.id}
          handleClose={() => setIsDelete(false)}
          afterFolderFinallyDelete={() => navigate('/trash')}
        ></FinallyDeleteFolderModalController>
      )}
    </PageInnerContainer>
  ) : (
    <></>
  );
});
